import { StyledFlexRow, StyledSection } from './Styles'

// This solution fixes the type issue, but causes styling to fuck up...
// const FlexRow = (props: FlexRowProps) => <StyledFlexRow {...props} />
const FlexRow: any & {
  Section: typeof StyledSection
} = StyledFlexRow

FlexRow.Section = StyledSection

export default FlexRow
